import { LegalPageView } from "@/components/LegalPageView";

export default function Terms() {
  return <LegalPageView page="terms" title="Terms of Service" />;
}
